import { useSyncExternalStore as useSyncExternalStore$1 } from 'use-sync-external-store/shim/index.js';

// Temporary workaround due to an issue with react-native uSES - https://github.com/TanStack/query/pull/3601
const useSyncExternalStore = useSyncExternalStore$1;

export { useSyncExternalStore };
//# sourceMappingURL=useSyncExternalStore.mjs.map
